import { takeLatest, call, fork, put } from 'redux-saga/effects';
import { Logger } from '@/services/errors/appLogger';
import {
    templateTagListSuccess,
    templateTagListError,
    templateTagDeleteSuccess,
    templateTagDeleteError,
} from '../store/templateTagList/actions';
import { loadTemplatesTags, templatesTagsDelete } from '../services/ApiCategories/templates';

function* loadTemplatesTagsList(action): any {
    const { payload } = action;
    try {
        const templateTagList = yield call(loadTemplatesTags, payload.type);
        yield put(templateTagListSuccess(templateTagList));
    } catch (e) {
        yield put(templateTagListError());
        Logger.error(e);
    }
}
function* deleteTemplateTag(action): any {
    const { payload } = action;
    try {
        yield call(templatesTagsDelete, payload.name, payload.type);
        yield put(templateTagDeleteSuccess(payload.name));
    } catch (e) {
        yield put(templateTagDeleteError());
        Logger.error(e);
    }
}

function* watchLoadTemplatesTagsList(): any {
    yield takeLatest('@@templateTagList/LOADING_START', loadTemplatesTagsList);
}
function* watchDeleteTemplateTag(): any {
    yield takeLatest('@@templateTagList/DELETE_START', deleteTemplateTag);
}

const templateTagListSagas = [fork(watchLoadTemplatesTagsList), fork(watchDeleteTemplateTag)];

export default templateTagListSagas;
